module.exports = __webpack_public_path__ + "img/linea.8809fe2c.png";